// Pure decision for the building contact route (FUN-1338), kept out of the
// route so it can be unit-tested without a router.
import { pickDefaultBuilding } from "@/lib/defaultBuilding";

/**
 * Which building `?building=` should point at when the contact page for
 * `buildingId` loads. The app reads the building from `?building=` and
 * BuildingUserProvider bounces any value the user cannot open, so we only ever
 * point it at a building they *can* open:
 *   - the building in the path, when they have access to it;
 *   - otherwise their default building (the provider's own rule), so the
 *     provider does not redirect them off the route before the page can show
 *     its "no access" message;
 *   - null when they belong to no building at all (the provider shows its own
 *     no-workspace screen).
 */
export function resolveContactBuildingTarget(
  buildingId: string,
  userBuildingIds: string[],
): string | null {
  if (userBuildingIds.includes(buildingId)) return buildingId;
  return pickDefaultBuilding(userBuildingIds) ?? null;
}
